import { Action } from '@ngrx/store';

import { VIEW_MODES } from './members.interfaces';
import { Account } from '@libs/src/models/account.model';
import { Group } from '@libs/src/models/group.model';

export const MEMBERS_DELETE_CATEGORIES_TYPE = '[members] delete categories';
export const MEMBERS_GET_INITIAL_PAGE_TYPE = '[members] get initial';
export const MEMBERS_INITIALIZE_TYPE = '[members] initialize';
export const MEMBERS_GET_PAGE_TYPE = '[members] get page';
export const MEMBERS_ADD_PAGE_TYPE = '[members] add page';
export const MEMBERS_RESET_RESULTS_TYPE = '[members] reset results';
export const MEMBERS_RESET_STATE_TYPE = '[members] reset state';
export const MEMBERS_SET_CURRENT_PAGE_TYPE = '[members] set current page';
export const MEMBERS_SET_ADMIN_MODE = '[members] set admin mode';
export const MEMBERS_SET_VIEW_MODE = '[members] set view mode';
export const MEMBERS_UPDATE_SEARCH_PARAMS_TYPE =
  '[members] update search params';
export const MEMBERS_UPDATE_ACCOUNT = '[members] update account';
export const MEMBERS_REMOVE_ACCOUNT = '[members] remove account';
export const MEMBERS_REMOVE_ACCOUNT_SUCCESS =
  '[members] remove account success';
export const MEMBERS_REMOVE_ACCOUNT_ERROR = '[members] remove account error';
export const MEMBERS_REMOVE_ACCOUNTS_SUCCESS =
  '[members] remove accounts success';
export const MEMBERS_REMOVE_ACCOUNT_MEMBERSHIP =
  '[members] remove account membership';

export class MembersAction implements Action {
  constructor(
    public type = '',
    public payload: any = {},
  ) {}
}

export function GetInitialPage(payload?: any): MembersAction {
  return new MembersAction(MEMBERS_GET_INITIAL_PAGE_TYPE, payload);
}

export function Initialize(payload: any): MembersAction {
  return new MembersAction(MEMBERS_INITIALIZE_TYPE, payload);
}

export function GetPage(payload: { pageIndex: number }): MembersAction {
  return new MembersAction(MEMBERS_GET_PAGE_TYPE, payload);
}

export function AddPage(payload: any): MembersAction {
  return new MembersAction(MEMBERS_ADD_PAGE_TYPE, payload);
}

export function ResetResults(): MembersAction {
  return new MembersAction(MEMBERS_RESET_RESULTS_TYPE);
}

export function ResetState(): MembersAction {
  return new MembersAction(MEMBERS_RESET_STATE_TYPE);
}

export function SetCurrentPage(payload: number): MembersAction {
  return new MembersAction(MEMBERS_SET_CURRENT_PAGE_TYPE, payload);
}

export function UpdateGroupSearchParams(payload: any): MembersAction {
  return new MembersAction(MEMBERS_UPDATE_SEARCH_PARAMS_TYPE, payload);
}

export function SetAdminMode(payload: boolean) {
  return new MembersAction(MEMBERS_SET_ADMIN_MODE, payload);
}

export function SetViewMode(payload: VIEW_MODES) {
  return new MembersAction(MEMBERS_SET_VIEW_MODE, payload);
}

export function RemoveAccount(payload: any): MembersAction {
  return new MembersAction(MEMBERS_REMOVE_ACCOUNT, payload);
}

export function RemoveAccountSuccess(payload: any): MembersAction {
  return new MembersAction(MEMBERS_REMOVE_ACCOUNT_SUCCESS, payload);
}

export function RemoveAccountError(payload: any): MembersAction {
  return new MembersAction(MEMBERS_REMOVE_ACCOUNT_ERROR, payload);
}

export function RemoveAccountsSuccess(payload: any): MembersAction {
  return new MembersAction(MEMBERS_REMOVE_ACCOUNTS_SUCCESS, payload);
}

export function UpdateAccount(payload: {
  pageIndex: number;
  itemIndex: number;
  account: Account;
}) {
  return new MembersAction(MEMBERS_UPDATE_ACCOUNT, payload);
}

export function RemoveAccountMembership(payload: Account): MembersAction {
  return new MembersAction(MEMBERS_REMOVE_ACCOUNT_MEMBERSHIP, payload);
}

export function DeleteMemberCategories(payload: {
  categories: string[];
  group: Group;
  type: string;
}): MembersAction {
  return new MembersAction(MEMBERS_DELETE_CATEGORIES_TYPE, payload);
}
